import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { CustomButton } from "@/components/ui-elements/CustomButton";
import { AppMenu } from "../ui-parts/Header/AppMenu";

const Wrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  backgroundColor: "#F0F0F0",
  marginTop: "194px",
}));

const TitleWrapper = styled(Typography)(() => ({
  color: "#303030",
  fontSize: "32px",
  fontWeight: 500,
  lineHeight: "normal",
  fontStyle: "normal",
  marginBottom: "-5px",
}));

const DescriptionWrapper = styled(Typography)(() => ({
  color: "#303030",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "normal",
  fontStyle: "normal",
  marginTop: "74px",
  textAlign: "center",
}));

const PermissionDenied = () => {
  return (
    <>
      <AppMenu attachListItem={false} />
      <Wrapper>
        <TitleWrapper variant="h2">権限がありません</TitleWrapper>
        <DescriptionWrapper variant="h6">
          このページへのアクセス権限がありません。
          <br />
          管理者にお問い合わせください。
        </DescriptionWrapper>
        <CustomButton
          label="ホームにもどる"
          variant="cancel"
          onClick={() => window.location.replace("/views/")}
          sx={{ marginTop: "131px", width: "180px", height: "40px" }}
        ></CustomButton>
      </Wrapper>
    </>
  );
};

export default PermissionDenied;
